
























import { namespace } from 'vuex-class';
import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { AcgnPop, AcgnTable } from '@acgn/herm/src/ui';
const StatisticAction = namespace('desk/statistic').Action;

@Component({
  components: {
    AcgnPop,
    AcgnTable
  }
})

/**
 * 项目明细字段修改历史记录-公共弹窗
 */
export default class AcgnPopFiledHistory extends Vue {
  public name: string = 'AcgnPopFiledHistory';

  // 数据
  @Prop({
    type: Object, default: () => ({
      apiType: 1, // 请求类型 ,1：格子记录 2：逾期记录
      userId: null, // 用户id
      cycle_type: 3, // 周期类型【 1：周、2：月、3：非时间】
      project_id: null // 漫画id
    })
  }) private options: object;

  @StatisticAction private reviseLog: any; // 格子记录
  @StatisticAction private reviseOverdueLog: any; // 逾期记录

  private apiKey: any = {
    1: 'reviseLog',
    2: 'reviseOverdueLog'
  };

  private show = false; // 是否显示弹窗

  private pageConfig: any = { // 分页数据
    total: 0,
    currentPage: 1
  };

  // 列表配置
  private tableConfig: any = {
    height: 300,
    columns: [
      {
        label: '修改对象',
        prop: 'uname',
        width: 100
      },
      {
        label: '修改周期',
        prop: 'time_slot'
      },
      {
        label: '修改字段',
        prop: 'field'
      },
      {
        label: '修正值',
        prop: 'revised_num'
      },
      {
        label: '修改人',
        prop: 'up_uname'
      },
      {
        label: '修改时间',
        prop: 'created_time'
      },
      {
        label: '备注',
        prop: 'described'
      }
    ],
    data: []
  };

  // 搜索
  private search() {
    this.initSearh({ page: 1 });
  }

  // table组件获取数据更新数据接口
  private async initSearh({ page }: { page: any }) {
    const { tableConfig, pageConfig } = this;
    const options = {
      page,
      size: 20,
      ...this.options
    };

    const { result, paging } = (await (this as any)[this.apiKey[(this.options as any).apiType]](options));
    result.list.forEach((item: any) => {
      const name = item.type === 1 ? '逾期审批' : '逾期提交';
      item.field = (this.options as any).apiType === 1 ? '件数' : name;
    });
    tableConfig.data = result.list;
    pageConfig.currentPage = paging.page;
    pageConfig.pageSize = paging.size;
    pageConfig.total = paging.total;

    const { size, ...args } = options;
    this.$setFormCache({ ...args });
  }

  private cliHistory() {
    this.show = true;
    this.search();
  }
}
